type Props = {
  color: string;
};

export default function CameraIcon(prop: Props) {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0008 13.2C11.7681 13.2 13.2008 11.7674 13.2008 10C13.2008 8.23274 11.7681 6.80005 10.0008 6.80005C8.23347 6.80005 6.80078 8.23274 6.80078 10C6.80078 11.7674 8.23347 13.2 10.0008 13.2Z"
        fill={prop.color}
      />
      <path
        d="M7 0L5.17 2H2C0.9 2 0 2.9 0 4V16C0 17.1 0.9 18 2 18H18C19.1 18 20 17.1 20 16V4C20 2.9 19.1 2 18 2H14.83L13 0H7ZM10 15C7.24 15 5 12.76 5 10C5 7.24 7.24 5 10 5C12.76 5 15 7.24 15 10C15 12.76 12.76 15 10 15Z"
        fill={prop.color}
      />
    </svg>
  );
}
